module.exports = __webpack_public_path__ + "img/icon_safe.cabc102c.png";